import $ from 'jquery';

export const RealEstateSearchResultItemComponent = {
	bindings: {
		realEstate: '<',
		isList: '<'
	},
	templateUrl: 'real-estate-search-result-item.html',
	controller: class RealEstateSearchResultItemComponent {
		constructor($rootScope, favouriteService, $scope, loginService, $timeout) {
			'ngInject';
			this.$rootScope = $rootScope;
			this.favouriteService = favouriteService;
			this.$scope = $scope;
			this.loginService = loginService;
			this.$timeout = $timeout;
			this.$scope.$watch('$ctrl.$rootScope.isLoggedIn', (newValue) => {
				this.isLoggedIn = newValue;
			});
			this.$scope.$on('estateLikedToList', (e, info) => {
				if (this.item.comissionId == info.id) {
					this.item.liked = info.liked;
				}
			});
		}

		$onInit() {
			this.isLoggedIn = this.$rootScope.isLoggedIn;
			this.initSliders();
		}

		initSliders() {
			let vm = this;
			if (this.item && angular.element('.m17-item-slick_' + this.item.comissionId).length) {
				vm.lazyBgImg(true, 0);
				angular.element('.m17-item-slick_' + this.item.comissionId).on('init', (event, slick) => {
					vm.lazyBgImg(angular.element(slick.$slides.get(0)), 0);
				});
				angular.element('.m17-item-slick_' + this.item.comissionId).on('beforeChange', (event, slick, slide, nextSlide) => {
					if (nextSlide >= vm.item.images.length) {
						nextSlide = vm.item.images.length - 1;
					}
					vm.lazyBgImg(angular.element(slick.$slides.get(nextSlide)), nextSlide);
				});
			} else {
				vm.$timeout(() => {
					vm.initSliders();
				}, 500);
			}
		}

		lazyBgImg(element, nextSlide) {
			let vm = this;
			if (element) {
				let lazyBgImgs = angular.element('.m17-item-slick_' + vm.item.comissionId + '_' + nextSlide);
				$.each(lazyBgImgs, function (index, el) {
					$(el).css('background-image', 'url(' + vm.item.images[nextSlide].url + ')');
				});
			}
		}

		$onChanges(changes) {
			if (changes.realEstate) {
				this.item = angular.copy(this.realEstate);
				this.initSliders()
			}
			if (changes.isList) {
				if (this.isList) {
					// TODO valami miatt ezután elmászik a carousel slide indexálás
					angular.element('.m17-item-slick_' + this.item.comissionId).slick('refresh');
				}
			}
		}

		navigateToProperty($event) {
			this.checkEvent($event);
		}

		// just for logged in users
		setLiked() {
			window.dataLayer.push({
				event: 'propertyLike',
				propertyID: this.item.comissionId
			});
			this.favouriteService.setFavourite(this.item.comissionId).then((response) => {
				this.item.liked = !this.item.liked;
				this.$scope.$emit('estateLiked', {
					id: this.item.comissionId,
					liked: this.item.liked
				});
			}).catch((error) => {
				console.log(error);
			});
		}

		checkEvent($event) {
			if (angular.element($event.target).is(':button')) {
				$event.preventDefault();
			} else {
				window.location.href = this.item.url;
			}
		}

		// loginolás

		showLogin($event) {
			this.loginService.openLoginForm($event);
		}

		hovered() {
			if (this.promise) {
				this.$timeout.cancel(this.promise);
			}
			this.promise = this.$timeout(() => {
				this.$scope.$emit('hoverOnElement', this.item);
			}, 500);
		}

		cancelHovered() {
			if (this.promise) {
				this.$timeout.cancel(this.promise);
			}
		}
	}
};
